import PropTypes from 'prop-types';

import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

function ModalSection({ title, subtitle, children }) {
  return (
    <Stack gap={3}>
      <Stack>
        <Heading component="h2" size="lg" wrap="wrap">
          {title}
        </Heading>
        <Text component="p" size="lg" color="secondary">
          {subtitle}
        </Text>
      </Stack>
      {children}
    </Stack>
  );
}

ModalSection.propTypes = {
  children: PropTypes.element,
  subtitle: PropTypes.string,
  title: PropTypes.string,
};

export default ModalSection;
